module.exports = __webpack_public_path__ + "static/dotted-people-e92f6ad2fdb152af5e7c99b505558c0b.jpg";